import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { CoordinationCurrency, CoordinationCurrencyDisplayName } from 'server/enums/CoordinationCurrency';

import { CoordinationsOverview, CoordinationViewModel } from './model';

import { PageLoadingIndicator } from 'core/actionloadingindicator/view';
import { PCDismissible } from 'portcall/pcdismissible/view';
import { PCSortable } from 'portcall/pcsortable/view';

export const CoordinationsOverviewView = SuperCritical(({ model: m } : { model : CoordinationsOverview }) =>
    <div className="coordinationsoverview pc-page-fixedwidth">
        <div className="header">
            Coordination Configurator
        </div>
        <div className="body">
            <TableHeader model={m} />
            <TableBody model={m} />
            <AddCoordinationLink />
        </div>
        <PageLoadingIndicator loading={m.Loading} />
    </div>
);

const TableHeader = SuperCritical(({ model: m } : { model : CoordinationsOverview }) =>
    <div className="coordinations-table-header">
        <span className="coordinations-col col-title">Coordination Title</span>
        <span className="coordinations-col col-admin-notes">Admin Notes</span>
        <span className="coordinations-col col-description">Description</span>
        <span className="coordinations-col col-currency">Status</span>
        {m.MilestoneTypes().map(t =>
            <span className="coordinations-col milestone-col" key={t.Id()}>{t.Nickname()}</span>
        )}
        <span className="coordinations-col col-actions">&nbsp;</span>
    </div>
);

const TableBody = SuperCritical(({ model: m } : { model : CoordinationsOverview }) =>
    <PCSortable
        className="coordinations-table-body"
        items={m.Coordinations}
        onSort={m.OnSortCoordinations}
        rowFactory={c =>
            <CoordinationRow coordination={c} model={m} key={c.Model.Id()} />
        }
    />
);

const CoordinationRow = SuperCritical(({ coordination: c, model: m } : { coordination : CoordinationViewModel, model : CoordinationsOverview }) =>
    <li className="coordinations-table-row">
        <span className="coordinations-col col-title">{c.Model.Title()}</span>
        <span className="coordinations-col col-admin-notes">{c.Model.AdminNotes()}</span>
        <span className="coordinations-col col-description">{c.Model.Description()}</span>
        <span className="coordinations-col col-currency">{CoordinationCurrencyDisplayName[c.Model.Currency()]}</span>
        {m.MilestoneTypes().map(t =>
            <span className="coordinations-col milestone-col" key={t.Id()}>
                <span
                    className={cx("milestone-indicator pc-breaker-light", {
                        "pc-breaker-active": c.ApplicableForMilestoneType(t)
                    })}
                />
            </span>
        )}
        <span className="coordinations-col col-actions">
            <a href="" className="fa fa-bars actions-link" onClick={noDefault(() => c.ShowActionsMenu(true))} />
            <CoordinationRowActionsMenu coordination={c} />
        </span>
    </li>
);

const CoordinationRowActionsMenu = SuperCritical(({ coordination: c } : { coordination : CoordinationViewModel }) =>
    c.ShowActionsMenu() ?
        <PCDismissible className="pc-card actions-menu" onDismiss={() => c.ShowActionsMenu(false)}>
            <div className="action-item">
                <a href={`#!coordinationconfigurator?id=${c.Model.Id()}`}>Configure</a>
            </div>
            <div className="action-item">
                <a href="" onClick={noDefault(c.MenuAction(c.ToggleCurrency))}>{c.Model.Currency() === CoordinationCurrency.Current ? "Deprecate" : "Restore"}</a>
            </div>
        </PCDismissible> :
        null
);

const AddCoordinationLink = SuperCritical(() =>
    <div className="add-coordination-container">
        <a className="add-coordination-link" href="#!coordinationconfigurator">+ Add Coordination</a>
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/coordinationsoverview/view.tsx